import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {StoreSummary} from '../../../classes/models/store/StoreSummary';
import {Authority} from '../../../classes/enums/Authority';
import {DataService} from '../../../services/store/data.service';

/**
 * This component describes a navigation between Schedule, Store and Employees pages.
 */
@Component({
  selector: 'app-store-navigation',
  templateUrl: './store-navigation.component.html',
  styleUrls: ['./store-navigation.component.less'],
  imports: [CommonModule, RouterModule]
})
export class StoreNavigationComponent {
  dataService = inject(DataService);


  /** A store, which is currently selected. */
  store: StoreSummary;
  /** Assigns an Authority, so it could be used in HTML. */
  Authority = Authority;

  /**
   * Checks if any store is currently selected.
   */
  isStoreSelected(): boolean {
    this.store = this.dataService.selectedStore;
    return this.store !== null;
  }

  /**
   * Checks if a current user has access to see a specific page.
   * @param authoritiesForPage actions, allowed to be performed by a user.
   */
  showPage(...authoritiesForPage: Authority[]): boolean {
    return this.dataService.userHasAuthorities(authoritiesForPage);
  }
}
